<div class="d-flex">
	<ng-select [clearable]="false"
		[searchable]="false"
		[(ngModel)]="this.selectedHour"
		(change)="hoursMinutesChanged()"
		style="min-width: 128px;"
		placeholder="HH">
		<ng-option *ngFor="let hour of hours"
			[value]="hour">
			{{ hour }}
		</ng-option>
	</ng-select>
	<div class="mx-1 align-self-center">:</div>
	<ng-select [clearable]="false"
		[searchable]="false"
		[(ngModel)]="this.selectedMinute"
		(change)="hoursMinutesChanged()"
		class="me-2"
		style="min-width: 128px;"
		placeholder="MM">
		<ng-option *ngFor="let minute of minutes"
			[value]="minute">
			{{ minute }}
		</ng-option>
	</ng-select>
	<app-switcher *ngIf="!time"
		[theme]="'grey'"
		[mods]="['--no-border', '--vertical', '--xs']"
		[switchList]="[
            { switchName: 'AM', isSwitchActive: selectedAmPm === 'am', id: 'am' },
            { switchName: 'PM', isSwitchActive: selectedAmPm === 'pm', id: 'pm' },
        ]"
		(switched)="switchedAmPm($event)"></app-switcher>
</div>
